/**
 * Removes undefined, null values and blank strings from an object this is used for
 * filtering out unknown URL parameters.
 * @param params - The object to filter
 * @returns A new object with undefined and null values removed
 */
export const stripBlank = (params: any) => {
  return Object.keys(params)
    .filter((k) => params[k] !== undefined && params[k] !== null && params[k] !== "")
    .reduce((acc, key) => ({ ...acc, [key]: params[key] }), {});
};
